<template>
    <v-dialog v-model="modal" max-width="800px" @click:outside="$emit('close')">
        <v-card>
            <v-card-title>
                <span class="text-h5">{{ 'Add new station' }}</span>
            </v-card-title>
            <v-spacer></v-spacer>
            <v-card-subtitle>
                Select station and users to associate with the station. <b>NB! If station has an active station location, the current active station location will be ended and a new one will be started</b>
            </v-card-subtitle>
            <v-card-text>
                <v-container>
                    <v-row>
                        <v-autocomplete
                            v-model="selectedStation"
                            label="Station"
                            placeholder="Station"
                            :items="stations"
                            :loading="loading"
                            :menu-props="{ contentClass: 'station-menu' }"
                            item-text="name"
                            item-value="id"
                        />
                    </v-row>
                    <v-spacer></v-spacer>
                    <v-row>
                        <v-autocomplete
                            v-model="selectedUsers"
                            label="Users"
                            placeholder="Users"
                            :items="users"
                            :loading="loading"
                            :menu-props="{ contentClass: 'users-menu' }"
                            item-text="name"
                            item-value="id"
                            chips
                            multiple
                            return-object
                        >
                            <template v-slot:prepend-item>
                                <v-list-item
                                    ripple
                                    @click="handleSelectAllClick"
                                    @mousedown.prevent
                                >
                                    <v-list-item-action>
                                        <v-icon color="indigo darken-4">
                                            {{ toggleAllIcon }}
                                        </v-icon>
                                    </v-list-item-action>
                                    <v-list-item-content>
                                        <v-list-item-title>
                                            Select All
                                        </v-list-item-title>
                                    </v-list-item-content>
                                </v-list-item>
                                <v-divider class="mt-2"></v-divider>
                            </template>
                        </v-autocomplete>
                    </v-row>
                </v-container>
            </v-card-text>
            <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn
                    color="blue darken-1"
                    text
                    @click="handleCloseClick"
                >
                    Close
                </v-btn>
                <v-btn
                    :disabled="!saveButtonActive"
                    color="blue darken-1"
                    text
                    @click="handleSaveClick"
                >
                    Add
                </v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
import { mapActions, mapGetters, mapMutations, mapState } from 'vuex';

export default {
    name: 'CompaniesEdit',
    props: ['open'],
    data() {
        return {
            modal: true,
            selectedStation: null,
            selectedUsers: [],
            stations: [],
            users: [],
        };
    },
    computed: {
        ...mapState('company', ['loading', 'activeCompany']),
        toggleAllIcon() {
            if (this.selectedUsers.length === this.users.length) return 'mdi-close-box';
            if (this.selectedUsers.length > 0) return 'mdi-minus-box';
            return 'mdi-checkbox-blank-outline';
        },
        saveButtonActive() {
            // return this.selectedStation !== null && this.selectedUsers.length > 0 && !this.loading;
            // Allow to select 0 users
            return this.selectedStation !== null && !this.loading;
        },
    },
    async mounted() {
        this.stations = await this.fetchStations({company_id: this.activeCompany.id});
        this.users = await this.getActiveCompanyStationLocationsUsers();
    },
    methods: {
        ...mapActions('company', ['fetchStations', 'AddStationToCompany']),
        ...mapMutations('company', ['setLoading']),
        ...mapGetters('company', ['getActiveCompanyStationLocationsUsers']),
        handleCloseClick() {
            this.$emit('close');
        },
        async handleSaveClick() {
            if (!this.saveButtonActive) return alert('Please select a station');
            const params = {
                active_company: this.activeCompany,
                station_id: this.selectedStation,
                user_ids: this.selectedUsers.map(user => user.id),
            }
            await this.AddStationToCompany(params)
            this.$emit('close');
        },
        handleSelectAllClick() {
            if (this.selectedUsers.length === this.users.length) {
                this.selectedUsers = [];
            } else {
                this.selectedUsers = this.users;
            }
        },
    },
};
</script>

<style scoped>

.station-menu {
    max-height: 300px;
    overflow-y: auto;
}

</style>